export default class LabelTipo {
    static get CIRCULO() {
        return 'label-circulo';
    }

    static get BARRA() {
        return 'label-barra';
    }

    static get TEXTO() {
        return 'label-texto';
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return LabelTipo[name];
    }
}
